<div class="curtain">

<section class="component-modalDialog redesigned size-4">
    <header>
        {{title}}
        <a class="closeModalDialog fa fa-close" (click)="closeDialog()"></a>
    </header>
    <div class="contentContainer">
        <div class="col-4 no-height">
            {{message}}
        </div>
        <div class="col-2 no-height">
            <select
                    name="dialog-date-select"
                    id="dialog-date-select"
                    [(ngModel)]="selectedDate"
                    autofocus>
                <option *ngFor="let date of dates" [ngValue]="date">{{formatDate(date)}}</option>
            </select>
        </div>
    </div>
    <footer>
        <a class="button-primary" (click)="selectDate();">{{buttonLabel}}</a>
        <a class="button-secondary" (click)="closeDialog();">Zavřít</a>
    </footer>
</section>

</div><!-- curtain -->